import React from 'react';
import {Text, TextPriority} from '@wix/wix-ui-tpa/cssVars';
import {TagSmall} from '@wix/wix-ui-icons-common';
import {CartItemDataHook} from '../../CartItem';
import s from '../../CartItem.scss';
import {LineItemModel} from '../../../../../../domain/models/LineItems/LineItem.model';
import {useControllerProps} from '../../../../../../domain/controllers/ControllerContext';

export const Discounts = ({lineItem}: {lineItem: LineItemModel}) => {
  const {couponAlignmentInCart} = useControllerProps().cartStore;

  return couponAlignmentInCart ? (
    <div data-hook={CartItemDataHook.Discounts}>
      {lineItem.discounts?.map(({name}, index: number) => (
        <div key={name} className={s.discountTag}>
          <TagSmall />
          <Text data-hook={`${CartItemDataHook.DiscountName}-${index}`} priority={TextPriority.secondary}>
            {name}
          </Text>
        </div>
      ))}
    </div>
  ) : (
    <div data-hook={CartItemDataHook.Discounts}>
      {lineItem.discounts?.map(({name}, index: number) => (
        <div
          key={`${CartItemDataHook.DiscountName}-${index}`}
          data-hook={`${CartItemDataHook.DiscountName}-${index}`}
          className={s.discountName}>
          {name}
        </div>
      ))}
    </div>
  );
};
